import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as applicationActions from '../../../actions/application';
import { APPLICATION_CONTEXTS } from '../../../constants';
import './styles.css';
const checkmark_image = require ('../images/checkmark.png')

const noop = () => {};

class ImageButton extends Component {
  /**************
   * Properties *
   **************/

  //  constructor(props) {
  //    super(props);
  //  }

  /**
   * The component's current state.
   *
   * @property {object}  state
   * @public
   *
   **/
  state = {
    src: this.getHighlightStateSource(this.props),
    src2: this.getHighlightStateSource2(this.props),
    hl: this.getHighlight(this.props),
    checked: this.props.checked || false,
    customImage: this.getCustomSource(this.props) || checkmark_image
  };

  /*********************
   * Protected methods *
   *********************/

  /**
   * Handles any mouseover interactions defined for this button.
   *
   * @protected
   *
   **/
  handleMouseOver = () => {
    if (!this.props.disableMouseOver && !this.props.disabled && this.props.context === APPLICATION_CONTEXTS.SERVICES) {
      this.props.resetCurrent(this.props.id);
      try{
        this.props.handleMouseOver(this.props.id)
      } catch (e) {
        console.log('no defined mouseover action')
      }
      this.setState({
        src: this.props.highlight,
        src2: this.props.highlight2,
        hl: this.getHighlight(this.props)
      });
    }
  };

  handleOnKeyUp = event => {
    if (
      event.key === 'Enter' &&
      this.props.current &&
      !this.props.disabled &&
      this.props.context === APPLICATION_CONTEXTS.SERVICES
    ) {
      event.stopPropagation();
      if (this.props.to) {
        this.props.history.push(this.props.to);
      } else if (this.props.handleSelect) {
        this.props.handleSelect(this.props.id);
      }
    }
  };

  handleOnClick = event => {
    if (
      this.props.current &&
      !this.props.to &&
      this.props.handleSelect &&
      this.props.context === APPLICATION_CONTEXTS.SERVICES
    ) {
      this.props.handleSelect(this.props.id);
    }
  };

  /**
   * Check if this item is highlightable or not
   *
   * @protected
   *
   */
  isHighlightable = () => {
    return this.props.highlight && this.props.unhighlight && !this.props.disabled;
  };

  hasImage2 = () => {
    return this.props.highlight2 || this.props.unhighlight2;
  };

  getHighlightStateSource(props) {
    let srcImg = props.unhighlight;
    if (props.current && props.highlight != null) {
      srcImg = props.highlight;
    }
    return srcImg;
  }

  getCustomSource(props) {
    let srcImg = props.custom_image;
    if (props.current && props.custom_image != null) {
      srcImg = props.custom_image;
    }
    return srcImg;
  }

  getHighlightStateSource2(props) {
    let srcImg = props.unhighlight2;
    if (props.current && props.highlight2 != null) {
      srcImg = props.highlight2;
    }
    return srcImg;
  }

  getHighlight(props) {
    let srcImg;
    try {
      srcImg = props.uh;
      if (props.current && props.highlight != null) {
        srcImg = props.hl;
      }
    } catch (e) {}

    if (!srcImg) {
      srcImg = {
        src: null
      };
    }

    return srcImg;
  }

  componentWillMount() {
    if (this.props.current) {
      document.addEventListener('keyup', this.handleOnKeyUp, false);
    }
  }

  componentWillUnmount() {
    if (this.props.current) {
      document.removeEventListener('keyup', this.handleOnKeyUp);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.current) {
      document.addEventListener('keyup', this.handleOnKeyUp, false);
    } else {
      document.removeEventListener('keyup', this.handleOnKeyUp);
    }
    if (nextProps.current !== this.props.current) {
      let srcImg = this.getHighlightStateSource(nextProps);
      let srcImg2 = this.getHighlightStateSource2(nextProps);
      let hl = this.getHighlight(nextProps);
      this.setState({ src: srcImg, src2: srcImg2, hl: hl });
    } else if (nextProps.unhighlight !== this.props.unhighlight) {
      let srcImg = nextProps.unhighlight;
      let srcImg2 = nextProps.unhighlight2;
      let hl = this.getHighlight(nextProps.uh);
      this.setState({ src: srcImg, src2: srcImg2, hl: hl });
    }
  }

  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    const arryclassnames = ['image-button'];
    if (this.props.className) {
      arryclassnames.push(this.props.className);
    }
    if (!this.state.src) {
      arryclassnames.push('hidden');
    }
    return (
      // Use onMouseUp, not onClick, as onClick can be called by a key press as well, and key presses are being listened for above
      <div className={arryclassnames.join(' ')} onMouseUp={this.handleOnClick}>
        <Link to={this.props.to || { hash: '#' }}>
          <div className="checkmark-container">
            <img
              className={`checkmark ${this.props.checked ? 'checkmark-visible' : 'checkmark-hidden'}`}
              src={this.state.customImage}
              alt=""
            />
          </div>
          <img
            className="image"
            src={this.state.src}
            alt={this.props.alt || ''}
            style={{ backgroundImage: `url(${this.state.hl.src})` }}
            onMouseOver={this.isHighlightable() ? this.handleMouseOver : noop}
          />
          {this.hasImage2() && (
            <div className="image2-container">
              <img className="image2" src={this.state.src2} alt="" />
            </div>
          )}
        </Link>
      </div>
    );
  }
}

const ConnectedImageButton = connect(
  state => ({
    context: state.application.currentContext
  }),
  dispatch => ({
    actions: bindActionCreators(
      {
        ...applicationActions
      },
      dispatch
    )
  })
)(ImageButton);

export default withRouter(ConnectedImageButton);
